// NOTE: We export these, since the Locator needs these values for device alignment
//  Additionally, it's important to note that, the reason we use specific sizes,
//  rather than using Tailwind classes, is the our NavBar has a specific height
//  at SM and LG sizes, and we need the items to fit and align perfectly.
export const NAV_LIST_ITEM_GAP_LG = 16
export const NAV_LIST_ITEM_GAP_SM = 12
export const NAV_LIST_ITEM_LG = 50
export const NAV_LIST_ITEM_SM = 36
